export const getOvalPoint = (width, height, corner) => {
  const radiusX = width / 2
  const radiusY = height / 2

  const angleMap = {
    topLeft: 225,
    topRight: 315,
    bottomLeft: 135,
    bottomRight: 45
  }

  const angle = (angleMap[corner] * Math.PI) / 180

  const x = radiusX + radiusX * Math.cos(angle)
  const y = radiusY + radiusY * Math.sin(angle)

  return { top: y, left: x }
}
